import Description from '../description/description';
import Focus from '../../../../shared/types/enums/focus';
import List from '../list/railsList/railsList';
import Main from '../../../../shared/types/enums/main';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import { store } from '../../../../shared/store/store';
import { useContext, useEffect } from 'react';

function Rails() {
  const {
    asset,
    complete,
    index,
    rails,
    onChangeElement,
    onItemClick,
    setAsset,
  } = useContext(MainContext);

  useEffect(() => {
    const {
      focus: { focus },
      router: { params },
    } = store.getState();

    if (rails?.length && rails[0]?.data?.length && (!asset || asset.dummy)) {
      const vIndex = Math.min(
        (params.current?.verticalIndex as number) || 0,
        rails.length
      );
      const hIndex = Math.min(
        (params.current?.horizontalIndex as number) || 0,
        rails[vIndex]?.data?.length || 0
      );
      setAsset(rails[vIndex]?.data[hIndex]);
    }

    // Update stack params on main page change initialization
    if (complete && !params.current?.previousFocus) {
      focus === Focus.SLIDERS && onChangeElement(Main.SLIDERS, 0);
      focus === Focus.RAILS_LIST ||
        (Array.isArray(focus) &&
          focus?.includes(Focus.RAILS_LIST) &&
          onChangeElement(Main.RAILS, 0, 0));
    }
  }, [rails, complete]);

  return rails ? (
    <>
      <Description />
      {rails.length ? (
        <List currentRail={index} rails={rails} onItemClick={onItemClick} />
      ) : null}
    </>
  ) : null;
}
export default Rails;
